import "react-toastify/dist/ReactToastify.css";
import "./index.css";

import { ConnectedRouter } from "connected-react-router";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { AccessGate } from "./Auth/AccessGate";
import { auth0Config, bypassAuth } from "./Auth/auth0Config";
import { PermissionsProvider } from "./Auth/PermissionsContext";
import { RealtimeProvider } from "./Realtime/RealtimeProvider";
import Layout from "./Components/Layout";
import { ModalContainer } from "./Components/ModalContainer";
import Analytics from "./Pages/Analytics";
import Backup from "./Pages/Backup";
import ContactMessages from "./Pages/ContactMessages";
import Deployment from "./Pages/Deployment";
import DeletedPages from "./Pages/DeletedPages";
import Dashboard from "./Pages/Dashboard";
import DesignLibrary from "./Pages/DesignLibrary";
import LayoutManager from "./Pages/LayoutManager";
import Logs from "./Pages/Logs";
import Login from "./Pages/Login";
import Metrics from "./Pages/Metrics";
import Migration from "./Pages/Migration";
import Template from "./Pages/Template";
import NetworkStatus from "./Pages/NetworkStatus";
import Newsletters from "./Pages/Newsletters";
import Permissions from "./Pages/Permissions";
import Redirections from "./Pages/Redirections";
import ConnectionsGraph from "./Pages/ConnectionsGraph";
import Architecture from "./Pages/Architecture/Architecture";
import Languages from "./Pages/Languages";
import Settings from "./Pages/Settings";
import Content from "./Pages/Content";
import ContentItem from "./Pages/ContentItem";
import SitePages from "./Pages/SitePages";
import PageEditor from "./Pages/PageEditor";
import Sitemaps from "./Pages/Sitemaps";
import Storage from "./Pages/Storage";
import Users from "./Pages/Users";
import ContactInfo from "./Pages/ContactInfo";
import Traduction from "./Pages/Traduction";
import TraductionDetail from "./Pages/Traduction/TraductionDetail";
import Taxonomie from "./Pages/Taxonomie";
import Categories from "./Pages/Categories";
import ContentTypes from "./Pages/ContentTypes";
import SearchTagsPage from "./Pages/SearchTags/SearchTagsPage";
import FragmentsPage from "./Pages/Fragments/FragmentsPage";
import ExternalApiPage from "./Pages/ExternalApi/ExternalApiPage";
import ShopDashboard from "./Pages/Shop/ShopDashboard";
import Orders from "./Pages/Shop/Orders";
import OrderDetail from "./Pages/Shop/OrderDetail";
import Customers from "./Pages/Shop/Customers";
import CustomerDetail from "./Pages/Shop/CustomerDetail";
import CoreReturns from "./Pages/Shop/CoreReturns";
import Stock from "./Pages/Shop/Stock";
import Quotes from "./Pages/Shop/Quotes";
import QuoteDetail from "./Pages/Shop/QuoteDetail";
import { history } from "./Redux/Index";

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route exact path="/">
            {bypassAuth ? <Redirect to="/dashboard" /> : <Login />}
          </Route>
          <Route path="/">
            <AccessGate audience={auth0Config.audience}>
              <PermissionsProvider>
              <RealtimeProvider>
              <Layout>
                <Route exact path="/dashboard" component={Dashboard} />
                <Route exact path="/boutique" component={ShopDashboard} />
                <Route exact path="/orders" component={Orders} />
                <Route exact path="/orders/:id" component={OrderDetail} />
                <Route exact path="/customers" component={Customers} />
                <Route exact path="/customers/:id" component={CustomerDetail} />
                <Route exact path="/returns" component={CoreReturns} />
                <Route exact path="/stock" component={Stock} />
                <Route exact path="/quotes" component={Quotes} />
                <Route exact path="/quotes/:id" component={QuoteDetail} />
                <Route exact path="/analytics" component={Analytics} />
                <Route exact path="/metrics" component={Metrics} />
                <Route exact path="/logs" component={Logs} />
                <Route exact path="/content/:contentTypeId/:itemId" component={ContentItem} />
                <Route exact path="/content/:contentTypeId" component={Content} />
                <Route exact path="/content" component={Content} />
                <Route exact path="/pages" component={SitePages} />
                <Route exact path="/architecture" component={Architecture} />
                <Route exact path="/connections" component={ConnectionsGraph} />
                <Route exact path="/new-page" component={PageEditor} />
                <Route exact path="/page/:id" component={PageEditor} />
                <Route path="/page/:lang/:slug+" component={PageEditor} />
                <Route exact path="/layout" component={LayoutManager} />
                <Route exact path="/template" component={Template} />
                <Route exact path="/design-library" component={DesignLibrary} />
                <Route exact path="/languages" component={Languages} />
                <Route exact path="/traduction" component={Traduction} />
                <Route exact path="/traduction/:schemaKey" component={TraductionDetail} />
                <Route exact path="/content-types" component={ContentTypes} />
                <Route exact path="/taxonomie" component={Taxonomie} />
                <Route exact path="/categories" component={Categories} />
                <Route exact path="/search-tags" component={SearchTagsPage} />
                <Route exact path="/fragments" component={FragmentsPage} />
                <Route exact path="/external-api" component={ExternalApiPage} />
                <Route exact path="/contact-info" component={ContactInfo} />
                <Route exact path="/redirections" component={Redirections} />
                <Route exact path="/sitemaps" component={Sitemaps} />
                <Route exact path="/migration" component={Migration} />
                <Route exact path="/storage" component={Storage} />
                <Route exact path="/permissions" component={Permissions} />
                <Route exact path="/network-status" component={NetworkStatus} />
                <Route exact path="/newsletters" component={Newsletters} />
                <Route exact path="/contact-messages" component={ContactMessages} />
                <Route exact path="/users" component={Users} />
                <Route exact path="/backup" component={Backup} />
                <Route exact path="/deployment" component={Deployment} />
                <Route exact path="/deleted-pages" component={DeletedPages} />
                <Route exact path="/settings" component={Settings} />
                <ModalContainer />
                <ToastContainer position={toast.POSITION.BOTTOM_RIGHT} autoClose={15000} />
              </Layout>
              </RealtimeProvider>
              </PermissionsProvider>
            </AccessGate>
          </Route>
        </Switch>
      </ConnectedRouter>
    );
  }
}
